import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Xin chào mọi người! Tôi là <span className="purple">Nguyễn Huy Mạnh</span>, hiện đang sống và làm việc tại <span className="purple">Hà Nội</span>.
            <br />
            <br />
            Tôi là một <span className="purple">Lập trình viên Phát triển Ứng dụng Di động</span> với thế mạnh chuyên sâu về hệ sinh thái Flutter. Mục tiêu hàng đầu của tôi là kiến tạo nên những ứng dụng không chỉ có độ hoàn thiện cao mà còn đạt hiệu năng tối ưu nhất.
            <br />
            <br />
            Bên cạnh niềm đam mê với những dòng code, tôi thường nạp lại năng lượng thông qua:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Chơi game giải trí 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Tập gym rèn luyện thể chất 🏋️
            </li>
            <li className="about-activity">
              <ImPointRight /> Chơi các môn thể thao vận động ⛹️
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Mạnh</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
